var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3014 17.9752C19.3014 19.2934 18.2328 20.362 16.9146 20.362C15.5964 20.362 14.5278 19.2934 14.5278 17.9752C14.5278 16.657 15.5964 15.5884 16.9146 15.5884C18.2328 15.5884 19.3014 16.657 19.3014 17.9752Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8506 14.7891C18.8506 15.8585 17.9838 16.7253 16.9145 16.7253C15.8452 16.7253 14.9783 15.8585 14.9783 14.7891C14.9783 13.7199 15.8452 12.853 16.9145 12.853C17.9838 12.853 18.8506 13.7199 18.8506 14.7891Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3948 12.6197C18.3948 13.689 17.528 14.5558 16.4586 14.5558C15.3893 14.5558 14.5225 13.689 14.5225 12.6197C14.5225 11.5505 15.3893 10.6837 16.4586 10.6837C17.528 10.6837 18.3948 11.5505 18.3948 12.6197Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5259 12.4374C16.5259 13.5066 15.659 14.3735 14.5896 14.3735C13.5204 14.3735 12.6536 13.5066 12.6536 12.4374C12.6536 11.368 13.5204 10.5012 14.5896 10.5012C15.659 10.5012 16.5259 11.368 16.5259 12.4374Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7108 9.99521C15.7108 11.4447 14.5357 12.6198 13.0862 12.6198C11.6367 12.6198 10.4614 11.4447 10.4614 9.99521C10.4614 8.54567 11.6367 7.37065 13.0862 7.37065C14.5357 7.37065 15.7108 8.54567 15.7108 9.99521Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9819 8.69505C18.9819 10.1166 17.8296 11.2689 16.4081 11.2689C14.9865 11.2689 13.834 10.1166 13.834 8.69505C13.834 7.27351 14.9865 6.12119 16.4081 6.12119C17.8296 6.12119 18.9819 7.27351 18.9819 8.69505Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0862 8.31202C13.0862 10.1018 11.6353 11.5528 9.84547 11.5528C8.05564 11.5528 6.60474 10.1018 6.60474 8.31202C6.60474 6.52219 8.05564 5.07128 9.84547 5.07128C11.6353 5.07128 13.0862 6.52219 13.0862 8.31202Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6003 9.52137C8.6003 11.6238 6.89589 13.3282 4.79344 13.3282C2.69098 13.3282 0.986572 11.6238 0.986572 9.52137C0.986572 7.41891 2.69098 5.7145 4.79344 5.7145C6.89589 5.7145 8.6003 7.41891 8.6003 9.52137Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87986 6.55403C9.87986 8.02789 8.68503 9.22272 7.21117 9.22272C5.73731 9.22272 4.54248 8.02789 4.54248 6.55403C4.54248 5.08016 5.73731 3.88534 7.21117 3.88534C8.68503 3.88534 9.87986 5.08016 9.87986 6.55403Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47246 5.41588C5.47246 7.75182 3.57888 9.6454 1.24294 9.6454C-1.09291 9.6454 -2.98657 7.75182 -2.98657 5.41588C-2.98657 3.08003 -1.09291 1.18637 1.24294 1.18637C3.57888 1.18637 5.47246 3.08003 5.47246 5.41588Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30368 10.9117C2.30368 13.1289 0.506305 14.9263 -1.71095 14.9263C-3.92813 14.9263 -5.72559 13.1289 -5.72559 10.9117C-5.72559 8.69448 -3.92813 6.89703 -1.71095 6.89703C0.506305 6.89703 2.30368 8.69448 2.30368 10.9117Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43085 3.36739C1.43085 5.22719 -0.0767579 6.7348 -1.93655 6.7348C-3.79628 6.7348 -5.30396 5.22719 -5.30396 3.36739C-5.30396 1.50766 -3.79628 -7.62939e-06 -1.93655 -7.62939e-06C-0.0767579 -7.62939e-06 1.43085 1.50766 1.43085 3.36739Z",
    fill: "#FAF6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5081 23.6988C21.5081 23.0498 22.4761 22.5235 23.67 22.5235C24.8639 22.5235 25.8318 23.0498 25.8318 23.6988L26.715 58.6762H23.67H20.625L21.5081 23.6988Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3809 22.589L25.2921 58.6762H26.7151L25.8318 23.6989C25.8318 23.1852 25.2255 22.7488 24.3809 22.589Z",
    fill: "#FEB412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.505 23.6987C21.505 23.0497 22.4729 22.5235 23.6668 22.5235C24.8606 22.5235 25.8286 23.0497 25.8286 23.6987L25.9035 26.6619C25.9035 26.0129 24.8606 25.4869 23.6668 25.4869C22.4729 25.4869 21.4302 26.0129 21.4302 26.6619L21.505 23.6987Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3777 22.5889L24.4529 25.5651C25.2836 25.7347 25.9034 26.1617 25.9034 26.662L25.8287 23.6988C25.8287 23.1851 25.2223 22.7487 24.3777 22.5889Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 19.8615C14.6738 19.1413 15.7473 18.5574 17.0716 18.5574C18.3959 18.5574 19.4695 19.1413 19.4695 19.8615L20.4492 58.6762H17.0716H13.6941L14.6738 19.8615Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8601 18.6299L18.8709 58.676H20.4491L19.4695 19.8615C19.4695 19.2916 18.7969 18.8074 17.8601 18.6299Z",
    fill: "#FEB412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6746 19.8615C14.6746 19.1413 15.748 18.5574 17.0723 18.5574C18.3967 18.5574 19.4704 19.1413 19.4704 19.8615L19.5533 23.1499C19.5533 22.4297 18.3967 21.8458 17.0723 21.8458C15.748 21.8458 14.5916 22.4297 14.5916 23.1499L14.6746 19.8615Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8611 18.6298L17.9443 21.9328C18.8658 22.1209 19.5534 22.5948 19.5534 23.1499L19.4705 19.8615C19.4705 19.2916 18.7979 18.8073 17.8611 18.6298Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3978 58.676H47.0044V47.0081L40.0039 36.4515L40.3976 43.1208",
    fill: "#FEB412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0038 36.4515L34.8459 38.3902L40.3977 43.1208L40.0038 36.4515Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9579 46.2178L40.0039 35.7125V36.4506L47.0044 47.0072L46.9579 46.2178Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8459 37.6513L40.0038 35.7125V36.4506L34.8459 38.3894",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4287 43.1207L30.9224 32.6734V58.676H40.4287",
    fill: "#FEB412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9223 32.6734L10.9207 40.5631V58.676H30.9223V32.6734Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.382 42.3305L30.9224 31.9343V32.6724L40.4285 43.1199L40.382 42.3305Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9207 39.824L30.9223 31.9343V32.6725L10.9207 40.5623",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6365 58.6763V46.5607L12.3623 48.7203V58.6763H22.6365Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 49.022L22.6365 46.9438V46.5603L12.3625 48.7202V58.6762H12.7505V49.022Z",
    fill: "#FEB412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7292 50.9315V45.073L23.6697 46.3467V51.6568L29.7292 50.9315Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0578 46.6485L29.7293 45.4563V45.0729L23.6699 46.3467V51.6568L24.0578 51.6104V46.6485Z",
    fill: "#FEB412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7398 56.4706V52.1198L36.0747 51.8184V56.362L38.7398 56.4706Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7398 46.4665L36.0747 45.9076V51.4075L38.7398 51.735V46.4665Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.584 45.8154L35.6052 45.8091L32.0889 45.0717V50.9178L35.584 51.3472V45.8154Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5836 51.7626L32.0884 51.3673V56.1994L35.5836 56.3419V51.7626Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2388 51.7244L35.1605 51.7148L32.0884 51.3673V51.7836L35.2388 52.14V56.3279L35.5836 56.3419V51.7627L35.2388 51.7237V51.7244Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0886 45.5211L35.2603 46.1864L35.2388 46.1927V51.3048L35.5837 51.3472V45.8154L35.605 45.8093L32.0886 45.0717V45.5211Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0747 46.3572L38.3949 46.8439V51.6927L38.7396 51.735V46.4665L36.0747 45.9076V46.3572Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.395 52.1121L36.0747 51.8272V52.2345L38.395 52.497V56.4565L38.7398 56.4706V52.1197L38.395 52.0807V52.1121Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3625 42.2934L22.6365 38.7383V42.5199L12.3625 45.401V42.2934Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 42.5952L22.6363 39.1742V38.7383L12.3623 42.2935V45.401L12.7502 45.2921V42.5952Z",
    fill: "#FEB412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4285 46.8207V51.9423L43.3844 52.3056V47.4407L40.4285 46.8207Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7195 47.5108V52.3467L45.9424 52.6197V47.9771L43.7195 47.5108Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3844 52.6449L40.4285 52.3106V56.5392L43.3844 56.6596V52.6449Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7195 56.6734L45.9424 56.7639V52.9343L43.7195 52.6828V56.6734Z",
    fill: "#160244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0396 47.818V52.2634L43.3746 52.3045V47.8884L43.3844 47.8905V47.4409L40.4285 46.8211V47.2705L43.0396 47.818Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3844 52.6449L43.0396 52.606L40.4285 52.3106V52.7268L43.0396 53.0221V56.6456L43.3844 56.6596V52.6449Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9424 52.9343L45.5976 52.8953L43.7195 52.6828V53.0991L45.5976 53.3114V56.7498L45.9424 56.7639V52.9343Z",
    fill: "#F92A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7195 47.5108V47.9606L45.5976 48.3544V52.5773L45.9424 52.6197V47.9771L43.7195 47.5108Z",
    fill: "#F92A27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessUserCard);
export default __webpack_public_path__ + "static/media/business-user-card.82fdac9066370e178766740eba7e3b08.svg";
export { ForwardRef as ReactComponent };